import { render } from "./ReceiverTransactionSingle.vue?vue&type=template&id=70fc505a&scoped=true"
import script from "./ReceiverTransactionSingle.vue?vue&type=script&lang=js"
export * from "./ReceiverTransactionSingle.vue?vue&type=script&lang=js"

import "./ReceiverTransactionSingle.vue?vue&type=style&index=0&id=70fc505a&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70fc505a"]])

export default __exports__